export const REGISTER_OF_DOCS_OPTION = [
  "icons",
  "inn",
  "code",
  "name",
  "category",
  "GP", //
  "DataConfirmation", //
  "contractNumber", //+
  "contractDate", //+
  "ContractCommencementDate",
  "workStartDate", //+
  "ContractValidity", //
  "avtovazAccount", //+
  "avtovazBank", //+
  "accountStartDate", //+
  "FormCode", //
  "printFormId", //+
  "dealerSignedDate", //+
  "closeDateForIS", //+
];
